// $( ".social--wrap" ).insertBefore( ".header-center .nav--button--primary" );


$(document).ready(function () {
    //home change header color on scroll
    // $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 100) {
    //         $(".home .site-header").addClass('bg-white').removeClass('bg-none');
    //     } else {
    //         $(".home .site-header").removeClass('bg-white').addClass('bg-none');
    //     }
    // })



    //gform
    $('input[type="file"]').each(function () {
        $(this).after('<p class="uploaded--file--name"></p>');
    });
    $('input[type="file"]').change(function () {
        var filename = $(this)
            .val()
            .replace(/C:\\fakepath\\/i, '');
        console.log(filename);
        $(this).siblings().append(filename);
    });

    //dropdown function
    $('.menu-item-has-children').each(function () {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function () {
        $(this).click(function (e) {
            e.preventDefault();

            $('.dropdown-link')
                .next()
                .not($(this).next())
                .removeClass('dropdown');
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
            } else {
                $(this).next().addClass('dropdown');
            }
        });
    });

    $('.mobile--inner--wrapper .menu-item-has-children').each(function () {
        $(this).addClass('acc-submenu');
    });
    $('.mobile--inner--wrapper .menu-item-has-children').each(function () {
        $(this)
            .children('a')
            .click(function (e) {
                // console.log("test");
                e.preventDefault();
                $(this).toggleClass('rotate');
                $(this).next().toggleClass('acc--menu--open');
                $(this).next().slideToggle('slow');
            });
    });

    $('.burger--menu--toggle').click(function () {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass('header--open')) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass('burger--closed');
            $('body').addClass('nav--open');

            //open menu
            $('.header-mobile-content')
                .addClass('header--open')
                .removeClass('header--closed');
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content')
                .removeClass('header--open')
                .addClass('header--closed');
            $('html, body').css({
                overflow: 'auto',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }

        setTimeout(function () {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay
    });

    // //
    // //close menu if click on page
    // //
    $(document).mouseup(function (e) {
        var container = $('.header--open, .header--burger');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass('header--open');
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'auto',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }
    });

    //hide navbar on scroll
    $(function () {
        var lastScrollTop = 0,
            delta = 5;
        $(window).scroll(function () {
            var nowScrollTop = $(this).scrollTop();
            var scroll = $(window).scrollTop();

            if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
                if (nowScrollTop > lastScrollTop) {
                    // ACTION ON
                    // SCROLLING DOWN
                    if (scroll >= 600) {
                        $('.site-header-scroll')
                            .removeClass('nav-down')
                            .addClass('nav-up');
                    }
                } else {
                    // ACTION ON
                    // SCROLLING UP
                    $('.site-header-scroll')
                        .removeClass('nav-up')
                        .addClass('nav-down');
                }
                lastScrollTop = nowScrollTop;
            }
        });
    });
});

$('.section--break').each(function () {
    $(this)
        .add($(this).nextUntil('.section--end'))
        .wrapAll('<div class="half--size"></div>');
});
